//receives messages from unity
export default function UnityMessageInit(vueStore) {
  const store = vueStore;

  const getMessageFromUnity = function (name, message) {
    switch (name) {
      case "sectionReached":
        break;
      case "openPopup":
        store.dispatch("set_popup", parseInt(message, 10));
        break;
    }
  };
  return getMessageFromUnity;
}
